/* Copyright (C) 2018-2019 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

export default interface DETAILVIEWS_RELATIONSHIP
{
	ID?                           : string;  // uniqueidentifier
	DETAIL_NAME?                  : string;  // nvarchar
	MODULE_NAME                   : string;  // nvarchar
	TITLE                         : string;  // nvarchar
	CONTROL_NAME                  : string;  // nvarchar
	RELATIONSHIP_ORDER?           : number;  // int
	TABLE_NAME                    : string;  // nvarchar
	PRIMARY_FIELD                 : string;  // nvarchar
	SORT_FIELD                    : string;  // nvarchar
	SORT_DIRECTION                : string;  // nvarchar
	// 03/31/2022 Paul.  Add Insight fields.
	INSIGHT_VIEW?                 : string;  // nvarchar
	INSIGHT_LABEL?                : string;  // nvarchar
	initialOpen?                  : boolean;
}

